import { Injectable } from "@angular/core";

import { SaysoEventData } from "../../../common/interfaces/analytics";

@Injectable({ providedIn: "root" })
/** This gets stubbed out in the teamPageAppModule. A provider is registered and the implementation is web-components/src/analytics.ts */
export abstract class AnalyticsService {
  abstract trackEvent(data: SaysoEventData): void;
}
